import { styled } from "styled-components";
import { devices } from "../../../Constants";

export const ProductFormWrapper = styled.form`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 2.5rem;

	@media only screen and ${devices.xl} {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		gap: 2rem;
	}

	.input-tag-container {
		border: 1px solid #b8c8cf;
		border-radius: 5px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 0.6rem;
		padding: 0.6rem;

		.tag-item {
			background: #003a50;
			display: inline-block;
			padding: 0.5rem 0.75rem;
			border-radius: 0.3rem;
			color: #ffffff;
		}

		.tag-item .close {
			height: 1.2rem;
			width: 1.2rem;
			font-size: 1.4rem;
			display: inline-flex;
			justify-content: center;
			align-items: center;
			margin-left: 0.6rem;
			cursor: pointer;
		}

		.tag-input {
			flex-grow: 1;
			padding: 0.3rem 0;
			border: none;
			outline: none;
		}
	}
`;

export const InputGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.9rem;

	input {
		border: ${(props) => (props.status ? "none" : "1px solid #B8C8CF")};
		border-radius: 0.5rem;
		padding: 0.7rem;
		color: #333333;
		font-weight: 500;
		font-size: 1rem;
		/* background: #ffffff; */
	}

	label {
		color: #999999;
	}

	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		margin: 0;
	}
`;

export const ButtonGroup = styled.div`
	display: flex;
	gap: 2rem;
	margin-top: 3.5rem;
`;

export const Button = styled.button`
	background: ${(props) => props.backgroundcolor};
	padding: ${(props)=> props.custom ? ".8rem" : "1.2rem"  };
	display: flex;
	align-items: center;
	gap: 0.5rem;
	color: ${(props) => props.color};
	border: ${(props) =>
		props.border ? "1px solid rgba(0, 103, 112, 0.7)" : "1px solid white"};
	border-radius: 1.25rem;
	cursor: pointer;
	width: ${(props)=> props.customwidth ? props.customwidth : "" };
	
`;

export const CustomButton = styled(Button)`
	
`

export const Formgroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
   //used in users management
	label {
		color: ${(props)=>props.type ? "#000000" : "#999999 "};
		font-weight:  ${(props)=>props.type ? "bolder" : "400"};
	}

	input.edit {
		padding: 8px 14px;
		border-radius: 6px;
		border: 1px solid #b8c8cf;
	}

	select.edit {
		border-radius: 0.5rem;
		padding: 0.7rem;
		border: 1px solid #b8c8cf;
	}

	.text_view {
		font-size: 1rem;
		font-weight: 500;
		padding: 0.7rem;
		border-radius: 0.5rem;
		background: #efefef4d;
	}

	.inputText {
		font-size: 1rem;
		font-weight: 500;
		padding: 0.7rem;
		border-radius: 0.5rem;
		background: #efefef4d;
	}
`;
